/*
import React, {useState} from 'react';

export default function IP({server, pageData}) {

	let [data, setData] = useState(pageData);

	return (
		<>
			<h1>If you see this page that means 302 redirect to /ip/127.0.0.1/websites page did not work</h1>
		</>
	)
};
*/

import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";

import CountryFlagAndName from '../../components/countryFlagAndName.js'
import DomainTable from '../../components/domainTable.js'
import GeoDistribution from '../../components/geoDistribution.js'

import DistributionByPopularityChart from '../../components/technologyDistributionChart.js'
import useGoogleCharts from '../../components/useGoogleCharts.js';
//import _getCoutryGoogleChartName from '../../helpers/helpers.js'
import CountriesLeadList from '../../components/countriesLeadList.js'
import TLDLeadList from '../../components/tldLeadList.js'

import { TechnologyDomains, TLDData, TechnologyGeoData, Distribution } from '../../../../server/routes/route-types.js'
import { IPPageResult } from '../../../../server/routes/ip.js'

import {
	_printNumber, 
} from '../../helpers/helpers'


// Define the main page data interface
// interface IPPageData {
// 	IP: string;
// 	TechnologyDomains: TechnologyDomains;
// 	DistributionByPopularity: Distribution;
// 	GeoData: {
// 		Header: {
// 			Title: string;
// 			Subtitle: string;
// 		};
// 		Countries: TechnologyGeoData[];
// 		UserCountry: string | null;
// 	};
// 	Usage: {
// 		DomainCount: number;
// 		TotalDomainCount: number;
// 		MostPopularCountry: {
// 			Country: string;
// 		} | null;
// 	};
// 	TLDs: TLDData[];
// 	ASNId: number;
// 	ASNName: string;
// 	DomainCount: number;
// 	NoDomainsFound: boolean;
// }

interface IPProps {
	server: string,
	pageData: unknown;
}

export default function IP({server, pageData}: IPProps) {

	const typedPageData = pageData as IPPageResult
	let [data, setData] = useState(typedPageData);

	return (
		<>
			<section className="section section-sm">
				<div className="container">
					<div className="row row-50">
						<div className="col-md-8 col-lg-8 col-xl-8">
							<IpLeftPanel props={data}/>
						</div>
						{
						<div className="col-md-4 col-lg-4 col-xl-4">
							<IpRightPanel props={data} />
						</div>
						}						
					</div>
				</div>
			</section>
		</>
	)
};

interface NoDomainIPProps {
	props: IPPageResult;
}

function NoDomainIP({props}: NoDomainIPProps) { 

	return (
		<div className="row row-50">
			<div className="col-12">
				<h4>We did not find any domains that are hosted on {props.IP} </h4>
			</div>
		</div>
	)
}

interface IpLeftPanelProps {
	props: IPPageResult;
}

function IpLeftPanel({props}: IpLeftPanelProps) {
	// (props.Usage.DomainCount > 0)
	return (
		<>
			<h2 style={{wordWrap: 'break-word'}}>{props.IP}</h2>
			<hr/>
			{
				props.NoDomainsFound && 
					<NoDomainIP props={props}/>
			}
			{
				!props.NoDomainsFound &&
					<HasDomainIP props={props}/>
			}
		</>
	)
}

interface IpAvailableReportsProps {
	props: IPPageResult;
}

function IpAvailableReports({props}: IpAvailableReportsProps) {
	return (
		<>
			<article className="box-bordered">
				<h4>Available Reports</h4>
				<br/>
				<div>
					<ul>
						<li>
							<Link 
								to={`/ip/${props.IP}/websites`}
								className="link-hover" 
								title={`List of websites that are hosted on ${props.IP}`}
							>
								Website List
							</Link>
						</li>                                       
					</ul>      
				</div>
			</article>
			<br />
		</>
	)
}

interface IpRightPanelProps {
	props: IPPageResult;
}

function IpRightPanel({props}: IpRightPanelProps) {
	return (
		<div className="row row-35 row-lg-50">
			<div className="col-sm-12 col-lg-12">
				<CountriesLeadList name={props.IP} reporttype='none' geoData={props.GeoData} />
				<TLDLeadList name={props.IP} reporttype='none' tlds={props.TLDs}/>
	
			</div>
		</div>
	)							
}

interface HasDomainIPProps {
	props: IPPageResult;
}

function HasDomainIP({props}: HasDomainIPProps) {

	const google = useGoogleCharts();

	return (
		<>
			<IpBrag props={props}/>

			<IpUsageStats props={props}/>
			<DistributionByPopularityChart name={props.IP} distribution={props.DistributionByPopularity} google={google}/>		

			<GeoDistribution geoData={props.GeoData} google={google}/>

			<IpWebsites props={props}/>
		</>
	)
}

interface IpBragProps {
	props: IPPageResult;
}

function IpBrag({props}: IpBragProps) {
	return (
		<>
			<br/>
			<p>
				We have discovered &nbsp;
				<Link 
					to={props.TechnologyDomains.Button!.Href}
					className="link-hover" 
					title={props.TechnologyDomains.Button!.Title} 
					rel="noopener nofollow" 
				> 
				<b>{_printNumber(props.Usage.DomainCount)} live websites</b>
				</Link>			
				&nbsp;	
				that are using {props.IP}.
			</p>
			<p>
				{/*
				<Link 
					to={`/create-report?ip=${props.IP}`}
					className="button button-secondary" 
					title={`Download list of websites using ${props.IP}`} 
					rel="noopener nofollow" 
				>
					Download Lead List
				</Link>
					*/				
				}

			</p>
			<br />
		</>
	)
}

interface IpUsageStatsProps {
	props: IPPageResult;
}

function IpUsageStats({props}: IpUsageStatsProps) {

	return (
		<>
			<div className="row row-50">
			<div className="col-12">
				<h3 className="text-left">IP usage statistics</h3>
				<table className="table-custom table-custom-striped table-custom-primary">
					<tbody>
						<tr>
							<td>Websites using {props.IP}</td>
							<td>
								<span className="icon text-primary">
									<Link 
										to={`/ip/${props.IP}/websites`}
										className="link-hover" 
										title={`List of websites that are hosted on  ${props.IP}`} 
									>
										<b>{_printNumber(props.Usage.DomainCount)}</b> websites
									</Link>
								</span>
							</td>
						</tr>

						{
							props.Usage.MostPopularCountry &&
								<tr>
									<td>
										Most popular in the country
									</td>
									<td>
										<b>
											<CountryFlagAndName countryCode={props.Usage.MostPopularCountry.Country} />
										</b>
									</td>
								</tr>
						}

						{
							(props.ASNId > 0) &&
							<tr>
								<td>
									ASN
								</td>
								<td>
									
									<Link 
									to={`/asn/${props.ASNId}`}
									className="link-hover" 
									title={`ASN AS${props.ASNId}`}
								>
									<b>AS{props.ASNId} - {props.ASNName}</b>
								</Link>									
									
								</td>
							</tr>
						}
					</tbody>
				</table>
			</div>
		</div>
	</>
	)
}


interface IpDistributionProps {
	props: IPPageResult;
}

function IpDistribution({props}: IpDistributionProps) {

	if (!props.DistributionByPopularity ) return null;

	return (
		<>
			<div className="row row-50">
				<div className="col-12">
					<h3 className="text-left">Distribution by websites popularity</h3>
					{props.IP} detection in the top websites by popularity
					<table className="table-custom table-custom-striped table-custom-primary">
						<tbody>
							<tr>
								<td>Top 10k sites</td>
								<td><span className="icon text-primary">{_printNumber(props.DistributionByPopularity.Top10KUsage)} websites</span></td>
							</tr>
							<tr>
								<td>Top 100k sites</td>
								<td><span className="icon text-primary">{_printNumber(props.DistributionByPopularity.Top100KUsage)} websites</span></td>
							</tr>
							<tr>
								<td>Top 1m sites</td>
								<td><span className="icon text-primary">{_printNumber(props.DistributionByPopularity.Top1MUsage)} websites</span></td>
							</tr>
							<tr>
								<td>Top 10m sites</td>
								<td><span className="icon text-primary">{_printNumber(props.DistributionByPopularity.Top10MUsage)} websites</span></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>		
		</>		
	)
}

interface IpWebsitesProps {
	props: IPPageResult;
}

function IpWebsites({props}: IpWebsitesProps) {

	return (
		<DomainTable domainList={props.TechnologyDomains}/>
	)
}
